"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPostRedirectEndpointRequest = exports.createGetRedirectsEndpointRequest = void 0;
function createGetRedirectsEndpointRequest(parameters) {
    return {
        method: 'GET',
        endpoint: `redirects`,
        params: Object.assign(Object.assign({}, (parameters.pagination && parameters.pagination.page
            ? { page: parameters.pagination.page }
            : undefined)), (parameters.pagination && parameters.pagination.perPage
            ? { perPage: parameters.pagination.perPage }
            : undefined)),
    };
}
exports.createGetRedirectsEndpointRequest = createGetRedirectsEndpointRequest;
function createPostRedirectEndpointRequest(url) {
    return {
        method: 'POST',
        endpoint: 'redirects',
        data: {
            url: url,
        },
    };
}
exports.createPostRedirectEndpointRequest = createPostRedirectEndpointRequest;
